import { render, staticRenderFns } from "./DevListMapTdt.vue?vue&type=template&id=1470bd35&scoped=true&"
import script from "./DevListMapTdt.vue?vue&type=script&lang=js&"
export * from "./DevListMapTdt.vue?vue&type=script&lang=js&"
import style0 from "./DevListMapTdt.vue?vue&type=style&index=0&id=1470bd35&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1470bd35",
  null
  
)

export default component.exports